import { userContextApi } from '@edulastic/api'
import { takeEvery, call, put } from 'redux-saga/effects'
import * as Sentry from '@sentry/browser'
import {
  STORE_EDUCATION_JOYRIDES_REQUEST,
  STORE_EDUCATION_JOYRIDES_SUCCESS,
  STORE_EDUCATION_JOYRIDES_FAILURE,
  educationJoyridesTracksSelector,
} from './educationJoyridesReducer'

function* storeEducationJoyridesSaga({ payload }) {
  try {
    yield call(userContextApi.storeEducationJoyrides, payload)
    yield put({
      type: STORE_EDUCATION_JOYRIDES_SUCCESS,
      payload,
    })
  } catch (err) {
    Sentry.captureException(err)
    yield put({
      type: STORE_EDUCATION_JOYRIDES_FAILURE,
      payload: err,
    })
  }
}

export function* watcherSaga() {
  yield takeEvery(STORE_EDUCATION_JOYRIDES_REQUEST, storeEducationJoyridesSaga)
}

export { educationJoyridesTracksSelector }
